const initProgressBar = (progressBar, mobileMenuState, heroHeight) => {
  const readingProgress = document.querySelector('.reading-progress');
  let lastProgress = 0;

  const updateProgress = () => {
    const position = window.scrollY;
    const postHeadHeight = document.querySelector('.animated-page-head').clientHeight;
    const contentHeight = document.querySelector('.page-post__content').clientHeight;
    const progress = (position / (contentHeight + postHeadHeight)) * 100;

    if (mobileMenuState.isOpened) {
      readingProgress.setAttribute('value', lastProgress);
    } else {
      lastProgress = progress;
      readingProgress.setAttribute('value', progress);
    }

    requestAnimationFrame(updateProgress);
  };

  if (readingProgress) updateProgress();

  const animateProgressBar = () => {
    const postContentHeight = document.querySelector('.page-post__content').clientHeight;

    if (window.scrollY > heroHeight && window.scrollY < heroHeight + postContentHeight) {
      progressBar.classList.add('show');
    } else {
      progressBar.classList.remove('show');
    }
  };

  window.addEventListener('scroll', animateProgressBar);
};

export { initProgressBar };
